<template>
    <div>
        <div class="features_table">
            <div class="table_titles">
                <div class="title_left">
                    Vyskúšaj si akýkoľvek balíček na 14 dní zadarmo
                </div>
                <div v-for="(plan, index) in plans_titles" :key="index" :class="`title_box ${plan.popular ? 'popular-plan' : ''}`">
                    <span v-if="plan.popular" class="popular_label">POPULÁRNY</span>
                    <h6 class="name">{{ plan.name }}</h6>
                    <h6 class="price">{{ plan.price }}<span>/{{ plan.pricePeriod }}</span></h6>
                    <a class="header_account_btn datalayer_menu">
                        <div class="arrow_right">
                            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11.5" cy="11.5" r="11.5" fill="#FAEFEF"/>
                                <path d="M16.4934 11.5H6.50659M12.6097 7.61621L16.4934 11.5L12.6097 7.61621ZM16.4934 11.5L12.6097 15.3838L16.4934 11.5Z" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <span>{{ plan.buttonText }}</span>
                    </a>
                </div>
            </div>
            <div class="row_table" :class="{'even': index % 2 === 0, 'odd': index % 2 !== 0}" v-for="(feature, index) in features" :key="`feature-${index}`">
                <span v-if="feature.hasTooltip">
                    <div class="has-tooltip" data-balloon-length="large" :aria-label="feature.tooltipText" data-balloon-pos="down">{{ feature.name }}</div> 
                </span>
                <span v-else>
                    <div>{{ feature.name }}</div> 
                </span>
                <span v-for="(plan, planIndex) in plans" :key="`plan-${planIndex}`" :class="{'popular-plan': plan.popular}" >
                    <template v-if="typeof plan.features[index] === 'boolean'">
                        <template v-if="plan.features[index]">
                            <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.14575 7L5.13558 11L15.1102 1" stroke="#15DE41" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </template>
                        <template v-else>
                            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.14062 13L13.1101 1M1.14062 1L13.1101 13" stroke="#D8D8D8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </template>
                    </template>
                    <template v-else>
                        <div>{{ plan.features[index] }}</div> <!-- Use div or p for non-boolean features -->
                    </template>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                plans_titles: [
                    {
                        name: "FREE",
                        price: "0 €",
                        pricePeriod: "mesačne",
                        buttonText: "začať teraz",
                        popular: false,
                    },
                    {
                        name: "BUSINESS",
                        price: "6 €",
                        pricePeriod: "mesačne",
                        buttonText: "začať teraz",
                        popular: true,
                    },
                    {
                        name: "PROFESSIONAL",
                        price: "7 €",
                        pricePeriod: "mesačne",
                        buttonText: "začať teraz",
                        popular: false,
                    },
                    {
                        name: "ULTRA",
                        price: "19 €",
                        pricePeriod: "mesačne",
                        buttonText: "začať teraz",
                        popular: false,
                    }
                ],
                plans: [
                    {
                        title: 'FREE',
                        price: 0,
                        popular: false,
                        features: [
                            "Max 3 naraz",
                            "Max 3",
                            "Len EUR",
                            "-",
                            "1 dostupná šablóna",
                            false, true,false,false,false,false,false,false,
                            false,false,false,false,false,false,false,false
                        ]
                    },
                    {
                        title: 'BUSINESS',
                        price: 6,
                        popular: true,
                        features: [
                            "Max 3 naraz",
                            "Neobmedzené",
                            "EUR, CZK, USD, GBP",
                            "EN, DE, CZ",
                            "3 dostupné šablóny",
                            false, true,true,true,true,true,false,true,
                            true,true,true,false,false,false,false,false
                        ]
                    },
                    {
                        title: 'PROFESSIONAL',
                        price: 7,
                        popular: false,
                        features: [
                            "Max 20 naraz",
                            "Neobmedzené",
                            "EUR, CZK, USD, GBP",
                            "EN, DE, CZ",
                            "3 dostupné šablóny",
                            true, true,true,true,true,true,true,true,
                            true,true,true,true,true,true,true,true
                        ]
                    },
                    {
                        title: 'BUSINESS',
                        price: 19,
                        popular: false,
                        features: [
                            "Neobmedzené",
                            "Neobmedzené",
                            "EUR, CZK, USD, GBP",
                            "EN, DE, CZ",
                            "3 dostupné šablóny",
                            true, true,true,true,true,true,true,true,
                            true,true,true,true,true,true,true,true
                        ]
                    }
                ],
                features: [
                    { name: "Počet cenových ponúk", hasTooltip: true, tooltipText: "Tooltip for Počet cenových ponúk" },
                    { name: "Počet položiek / podpoložiek v ponuke", hasTooltip: true, tooltipText: "Tooltip for Počet položiek / podpoložiek v ponuke" },
                    { name: "Meny ponúk", hasTooltip: true, tooltipText: "Tooltip for Meny ponúk" },
                    { name: "Jazyky ponúk", hasTooltip: true, tooltipText: "Tooltip for Jazyky ponúk" },
                    { name: "Šablóny ponúk", hasTooltip: false, tooltipText: "" },
                    { name: "Šablóna na mieru", hasTooltip: false, tooltipText: "" },
                    { name: "Export do PDF", hasTooltip: false, tooltipText: "" },
                    { name: "Titulná fotka v ponuke", hasTooltip: false, tooltipText: "" },
                    { name: "Obrázky k položkám", hasTooltip: false, tooltipText: "" },
                    { name: "Prepojenie na Superfaktura", hasTooltip: false, tooltipText: "" },
                    { name: "Farebné kombinácie", hasTooltip: false, tooltipText: "" },
                    { name: "Bez loga DOFFERO", hasTooltip: false, tooltipText: "" },
                    { name: "Recenzie klientov", hasTooltip: false, tooltipText: "" },
                    { name: "ONLINE prijatie/odmietnutie ponuky", hasTooltip: false, tooltipText: "" },
                    { name: "Sledovanie otvorenia ponuky", hasTooltip: false, tooltipText: "" },
                    { name: "Odosielanie ponúk z DOFFERO", hasTooltip: false, tooltipText: "" },
                    { name: "Databáza vlastných položiek", hasTooltip: false, tooltipText: "" },
                    { name: "Pod-účty a štatistiky", hasTooltip: false, tooltipText: "" },
                    { name: "Viaceré firmy s logami", hasTooltip: false, tooltipText: "" },
                    { name: "Voliteľné položky v ponuke", hasTooltip: false, tooltipText: "" },
                    { name: "Prioritná zákaznícka podpora", hasTooltip: false, tooltipText: "" }
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: Mont-SBold;
    src: url(../fonts/Mont-SemiBold.otf);
}
@font-face {
    font-family: Mont-Bold;
    src: url(../fonts/Mont-Bold.otf);
}
@font-face {
    font-family: Mont-Regular;
    src: url(../fonts/Mont-Regular.otf);
}
@font-face {
    font-family: Mont-Black;
    src: url(../fonts/Mont-Black.otf);
}
@font-face {
    font-family: Mont-Light;
    src: url(/fonts/Mont-Light.otf);
}
.features_table{
    widows: 1180px;
    margin: 0 auto;
    .table_titles{
        background-color: #fff;
        display: flex;
        .title_left{
            font-size: 22px;
            width: 314px;
            padding: 40px;
            font-weight: 800;
            border: 1px solid #E5E7EB;
        }
        .title_box{
            position: relative;
            flex: 1;
            display: grid;
            align-items: center;
            padding: 15px 23px;
            border: 1px solid #E5E7EB;
            &.popular-plan{
                border-top: 2px solid #C52060 !important; 
                border-left: 2px solid #C52060 !important; 
                border-right: 2px solid #C52060 !important; 
            }
            .popular_label{
                top: -8px;
                left: 61px;
                width: 90px;
                height: 15px;
                position: absolute;
                background-color: #F93C34;
                color: #fff;
                font-size: 12px;
                font-weight: 800;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
            }
            .name{
                font-size: 20px;
                background: linear-gradient(90deg, #F93C34 0%, #D73C78 50%, #C41F5F 100%);
                -webkit-background-clip: text;
                -moz-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: 800;
            }
            .price{
                font-size: 20px;
                background: linear-gradient(90deg, #F93C34 0%, #D73C78 50%, #C41F5F 100%);
                -webkit-background-clip: text;
                -moz-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: 800;
                span{
                    font-size: 15px;
                    font-weight: 300;
                    color: #6B6F8C;
                }
            }
            a.header_account_btn{
                position: relative;
                display: inline-flex;
                height: 49px;
                padding: 14px 18px 14px 12px;
                justify-content: center;
                align-items: center;
                gap: 7px;
                flex-shrink: 0;
                text-decoration: none;
                border: double 6px transparent;
                border-radius: 40px;
                border: solid 2px #F93C34;
                &:hover{
                    .arrow_right{
                        transform: translateX(112px);
                    }
                    span{
                        transform: translate(-24px,0px);   
                    }
                }
            }
            a.header_account_btn .arrow_right{
                width: 23px;
                height: 23px;
                flex-shrink: 0;
                border-radius: 23px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                transition: all .2s ease-in-out;
            }
            a.header_account_btn span{
                text-align: center;
                font-size: 14px;
                background: linear-gradient(90deg, #F93C34 0%, #D73C78 50%, #C41F5F 100%);
                -webkit-background-clip: text;
                -moz-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: 800;
                line-height: normal;
                letter-spacing: 0.56px;
                text-transform: uppercase;
                transition: all .2s ease-in-out;
            }
        }
    }
    .row_table{
        width: 100%;
        display: flex;
        .popular-plan {
            border-left: 2px solid #C52060 !important;
            border-right: 2px solid #C52060 !important;
        }
        &.even{
            background: #F7F7F7;
        }
        &.odd{
            background: #FFFFFF;
        }
        .has-tooltip {
            cursor: pointer;
            display: inline-block;
            padding-bottom: 4px;
            line-height: 1;
            border-bottom: 2px dashed #D0D3E5;
        }
        span{
            padding: 15px 23px;
            font-size: 14px;
            font-weight: 600;
            font-family: Mont-Light;
            line-height: 20px;
            border-right: 1px solid #E9E9E9; 
            border-left: 1px solid #E9E9E9; 
        }
        &:last-child {
            span {
                border-bottom: 1px solid #E9E9E9; 
                &:first-child {
                    border-bottom-left-radius: 10px; 
                }
                &:last-child {
                    border-bottom-right-radius: 10px; 
                }
            }
            span.popular-plan {
                border-bottom: 2px solid #C52060 !important; 
            }
        }
        span:not(:last-child) {
            border-right: none; 
        }
        span:first-child {
            color: #6B6F8C;
            width: 315px;
        }
        span:not(:first-child) {
            flex: 1;
            color: #212541;
        }
    }
}
</style>